<div class="portfolio-header">
    <div class="portfolio-header-main">
        <button type="button" class="circle" data-animation="showShadow" data-remove="3000" data-dismiss="modal"
            data-rel="189" id="close-popup-circle" (click)="navigatePortfolioList()"></button>
        <a routerLink="/getaquote.html" class="transition" id="InquireNow" tabindex="-1">Request a
            Quote</a>
    </div>
</div>

<div>
    <ion-slides #slidesRefClientsay [options]="imageslider" pager="true" (ionSlideDidChange)="down($event)">
        <ion-slide *ngFor="let arr of array">
            <div *ngIf="arr.show==true" style="display: contents">
                <img class="main-imge" src={{arr.img}} alt="Portfolio Inner Banner">
                <div class="content-section">
                    <div>

                        <h1>{{arr.nameprint}}</h1>
                        <p>{{arr.infosub}}</p>
                        <div class="webbutton">
                            <a class="web-btn" href="{{arr.websitelink}}" target="_blank" title="view website">
                                Visit Website
                                <img class="imgweb"
                                    src="https://firebasestorage.googleapis.com/v0/b/vidhema-72384.appspot.com/o/web-svgrepo-com-white.png?alt=media&token=e88bb2d1-ede4-477e-bc20-162bb2224ee7" alt="Website Icon">
                            </a>
                        </div>
                    </div>
                </div>

            </div>


        </ion-slide>
    </ion-slides>
    <div class="sliderarrowsbox">
        <button (click)="slidesRefClientsay.slidePrev()" class="backBtn">
            <svg class="i-arrow" viewBox="0 0 17 12">
                <path d="M1,6h14"></path>
                <path d="M12,1l4,5"></path>
                <path d="M12,11l4-5"></path>
            </svg>
            <span style="color: #fff;">Prev</span>
        </button>
        
        <div class="tech-stack-icon">

            <ul class="process-list half-description tech-des">
                <li *ngFor="let img of array[activeIndex]?.techArr">
                    <div class="list-title  list-space"><img
                            [src]="img" alt="Used Technology Image" class="tech-logo">
                    </div>
                </li>
            </ul>
        </div>

        <button (click)="slidesRefClientsay.slideNext()" class="nextBtn">
            <svg class="i-arrow" viewBox="0 0 17 12">
                <path d="M1,6h14"></path>
                <path d="M12,1l4,5"></path>
                <path d="M12,11l4-5"></path>
            </svg>
            <span style="color: #fff;">Next</span>
        </button>
    </div>

    <div class="details-sec">
        <div class="container">
            <ng-container *ngFor="let ss of array">
                <div class="row" *ngIf="ss.show">
                    <div class="col-md-4">
                        <p>{{ss.content}}</p>
                    </div>
                    <div class="col-md-8">
                        <img src="{{ss.img1}}" alt="Website Image">

                    </div>
                </div>
            </ng-container>
        </div>
    </div>
    <div>
    </div>

</div>